module.exports = __webpack_public_path__ + "static/media/swirl-right.2f4dcf70.png";